import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {WorkOrderType} from '../models/workOrderType.model';
import {FicheInterventionService} from './fiche-intervention.service';
import {WorkOrder} from '../models/workOrder.model';

@Injectable({
    providedIn: 'root'
})
export class WorkOrderService {

    public MODEL_URL = 'work-orders';
    private API_URL= environment.API_URL;

    constructor(private http: HttpClient) { }

    getWorkOrders(ficheInterventionId: number): Observable<WorkOrder[]> {
        return this.http.get<WorkOrder[]>(this.API_URL + 'fiches-interventions/' + ficheInterventionId + '/' + this.MODEL_URL);
    }

    delete(workOrder: WorkOrder): Observable<any> {
        return this.http.delete<any>(this.API_URL + 'fiches-interventions/' + workOrder.fiche_intervention_id + '/' + this.MODEL_URL + '/' + workOrder.id);
    }
}
